import { useSelector } from 'react-redux';
import { getBillingDataLoadingState } from 'reactApp/modules/billingData/billingData.selectors';

export const useSubscriptionCommunicationDataReady = (): boolean => {
    const { isLoaded: isBillingDataLoaded } = useSelector(getBillingDataLoadingState);

    return isBillingDataLoaded;
};
